<template>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" custom-class="qrCode-dialog">
      <div class="dialog-body">
        <el-image :src="code" fit="contain" style="width: 200px; height: 200px; margin: 0 auto;"></el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
      </div>
    </el-dialog>
</template>
<script>
  import {PostRequest,GetRequest} from "@/request";
  import qrcode from 'qrcode';
  export default {
    name: "ProjectDialog",
    props: [],
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '请扫描二维码付款',
        btnloading: false,
        qrCodeVo: {},
        code: '',
      }
    },
    methods: {
      async showDialog(val) {
        this.qrCodeVo = val;
        this.code = await qrcode.toDataURL(this.qrCodeVo.qrCode);
        this.dialogVisible = true;
      },
    },
  }
</script>
<style lang="less">
.qrCode-dialog{
  width: auto;
  max-width: 20%;
  .el-dialog__header {
    padding: 10px;
    background-color: #f3f7fa;
    border-radius: 5px 5px 0 0;
  }
  .el-dialog__body {
    width: 50%; /* 设置表单容器的宽度 */
    margin: 0 auto; /* 水平居中 */
    padding: 20px; /* 可选：增加内边距 */
  }

}
</style>